module.exports = __webpack_public_path__ + "static/media/nightSky.78338d89.mp4";